import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseSettings as SchemaDeliveryWarehouseSettings } from '../schemas/DeliveryWarehouseSettings';
import { type UpdateDeliveryWarehouseSettingsResponse as SchemaUpdateDeliveryWarehouseSettingsResponse } from '../schemas/UpdateDeliveryWarehouseSettingsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateDeliveryWarehouseSettingsByIdContentType = 'application/json' as const;
export type UpdateDeliveryWarehouseSettingsByIdRequest = SchemaDeliveryWarehouseSettings;
export type UpdateDeliveryWarehouseSettingsByIdResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse update request handled
     */
    '200': {
        'application/json': SchemaUpdateDeliveryWarehouseSettingsResponse;
    };
};
export type UpdateDeliveryWarehouseSettingsByIdResponseSuccess =
    UpdateDeliveryWarehouseSettingsByIdResponses['200']['application/json'];
export type UpdateDeliveryWarehouseSettingsByIdSearchParams = undefined;
export type UpdateDeliveryWarehouseSettingsByIdPathParameters = {
    warehouse_id: string;
};
export const UpdateDeliveryWarehouseSettingsByIdUrl = '/delivery/warehouse/{warehouse_id}/settings' as const;
export const UpdateDeliveryWarehouseSettingsByIdMethod = 'PATCH' as const;
export const getUpdateDeliveryWarehouseSettingsByIdUrl = (params: UpdateDeliveryWarehouseSettingsByIdPathParameters) =>
    UpdateDeliveryWarehouseSettingsByIdUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateDeliveryWarehouseSettingsByIdPathParameters) => String(params[param])
    );
